module.exports = __webpack_public_path__ + "static/media/quindio-46.ec1bfb95.jpg";